import { render, staticRenderFns } from "./ifromD.vue?vue&type=template&id=4827019a&scoped=true&"
import script from "./ifromD.vue?vue&type=script&lang=js&"
export * from "./ifromD.vue?vue&type=script&lang=js&"
import style0 from "./ifromD.vue?vue&type=style&index=0&id=4827019a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827019a",
  null
  
)

export default component.exports